import totalOffsetTop from "../helpers/totalOffsetTop";

class JumpLinks extends HTMLElement {
  constructor() {
    super();
    this.jumpLinks = this.querySelectorAll("[data-jump-index]");
  }

  connectedCallback() {
    const sections = document.querySelectorAll("#MainContent .shopify-section");

    this.jumpLinks.forEach((link) => {
      const targetIndex = Number(link.dataset.jumpIndex);
      const targetSection = sections[targetIndex];
      link.setAttribute("href", `#${targetSection.id}`);

      link.addEventListener("click", (e) => {
        e.preventDefault();
        this.jumpTo(targetIndex);
      });
    });
  }

  jumpTo(index) {
    const sections = document.querySelectorAll("#MainContent .shopify-section");
    const targetSection = sections[index];

    window.scroll({
      top: totalOffsetTop(targetSection) - 60,
      behavior: "smooth",
    });

    const firstFocusable = targetSection.querySelector("a, button, input");
    if (firstFocusable) {
      firstFocusable.focus({ preventScroll: true });
    } else {
      targetSection.setAttribute("tabindex", "-1");
      targetSection.focus({ preventScroll: true });
    }
  }
}

if (!customElements.get("jump-links")) {
  customElements.define("jump-links", JumpLinks);
}
